import UserRepository from '../modules/users/domain/repositories/UserRepository';
import User from '../modules/users/domain/aggregates/user/User';
import AuthenticationTokenRepository from '../modules/users/domain/repositories/AuthenticationTokenRepository';
import LessonRepository from '../modules/lessons/domain/repositories/LessonRepository';
import ExerciseRepository from '../modules/lessons/domain/repositories/ExerciseRepository';
import ExerciseResultRepository from '../modules/lessons/domain/repositories/ExerciseResultRepository';
import LessonResultRepository from '../modules/lessons/domain/repositories/LessonResultRepository';
import EventPublisher from '../../foundation/events/EventPublisher';
import ModalEvent from '../../foundation/events/ModalEvent';
import Timepoint from '../../foundation/time/Timepoint';
import CourseRepository from '../modules/lessons/domain/repositories/CourseRepository';
import ExerciseTemplateRepository from '../modules/lessons/domain/repositories/ExerciseTemplateRepository';
import OrganizationRepository from '../modules/organizations/domain/repositories/OrganizationRepository';

export default class Registry {

	public static instance: Registry;

	public me: User;

	public authenticationTokenRepository: AuthenticationTokenRepository;
	public exerciseRepository: ExerciseRepository;
	public exerciseResultRepository: ExerciseResultRepository;
	public exerciseTemplateRepository: ExerciseTemplateRepository;
	public lessonRepository: LessonRepository;
	public courseRepository: CourseRepository;
	public lessonResultRepository: LessonResultRepository;
	public organizationRepository: OrganizationRepository;
	public userRepository: UserRepository;

	public errorMessage: string | null;
	public confirmationMessage: string | null;
	public confirmationCallback: null | (() => void);
	public singleSignInTokenLoginTimepoint?: Timepoint;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new Registry();
	}

	public initialize () {
		this.authenticationTokenRepository = new AuthenticationTokenRepository();
		this.exerciseRepository = new ExerciseRepository();
		this.exerciseResultRepository = new ExerciseResultRepository();
		this.exerciseTemplateRepository = new ExerciseTemplateRepository();
		this.lessonRepository = new LessonRepository();
		this.courseRepository = new CourseRepository();
		this.lessonResultRepository = new LessonResultRepository();
		this.organizationRepository = new OrganizationRepository();
		this.userRepository = new UserRepository();

		this.errorMessage = null;
		this.confirmationMessage = null;
		this.confirmationCallback = null;
	}

	public async addErrorMessage (errorMessage: string) {
		this.errorMessage = errorMessage;
		await EventPublisher.getInstance().publish(new ModalEvent());
	}

	public async removeErrorMessage () {
		this.errorMessage = null;
		await EventPublisher.getInstance().publish(new ModalEvent());
	}

	public async askConfirmation (message: string, callback: () => void) {
		this.confirmationMessage = message;
		this.confirmationCallback = callback;
		await EventPublisher.getInstance().publish(new ModalEvent());
	}

	public async removeConfirmation () {
		this.confirmationMessage = null;
		this.confirmationCallback = null;
		await EventPublisher.getInstance().publish(new ModalEvent());
	}

	public async confirm () {
		if (this.confirmationCallback !== null) {
			await this.confirmationCallback();
		}
		await this.removeConfirmation();
	}
}


// WEBPACK FOOTER //
// ./code/project/global/Registry.ts